import { request } from "@/interface/helper";

const str = "dailyNews";

export const dailyNews = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/dailynews/list" }),
    add: data => request({ data, method: "post", url: "/dailynews/add" }),
    detail: data => request({ data, method: "post", url: "/dailynews/detail" }),
    edit: data => request({ data, method: "post", url: "/dailynews/modify" }),
    getLangs: data => request({ data, method: "get", url: "/dailynews/transfer" }),
    newsDetail: data => request({ data, method: "post", url: "/dailynews/getlangdetail" }),
    setOriginal: data => request({ data, method: "post", url: "/dailynews/setoriginallanguage" }),
    setLangDetail: data => request({ data, method: "post", url: "/dailynews/setlangdetail" }),
    setPublish: data => request({ data, method: "post", url: "/dailynews/publishlang" })
  }
};
